export default __webpack_public_path__ + "static/media/ic_left.c0e266ce.svg";